import { useState } from 'react';
import { Input, Button, Space, Alert, Typography } from 'antd';
import { KeyOutlined, CheckOutlined, DeleteOutlined } from '@ant-design/icons';
import { useApiKey } from './ApiKeyContext';
import './ApiKeyInput.css';

const { Text } = Typography;

export const ApiKeyInput = () => {
  const { apiKey, setApiKey, isConfigured } = useApiKey();
  const [inputValue, setInputValue] = useState('');
  const [showInput, setShowInput] = useState(!isConfigured);

  const handleSave = () => {
    if (inputValue.trim()) {
      setApiKey(inputValue.trim());
      setShowInput(false);
      setInputValue('');
    }
  };

  const handleClear = () => {
    setApiKey(null);
    setShowInput(true);
    setInputValue('');
  };

  if (!showInput && isConfigured) {
    return (
      <div className="api-key-display">
        <Space>
          <KeyOutlined />
          <Text type="success">
            API Key configured
            {apiKey && (
              <span className="api-key-preview">
                {' '}({apiKey.substring(0, 8)}...{apiKey.substring(apiKey.length - 4)})
              </span>
            )}
          </Text>
          <Button size="small" onClick={() => setShowInput(true)}>
            Change
          </Button>
          <Button size="small" danger icon={<DeleteOutlined />} onClick={handleClear}>
            Clear
          </Button>
        </Space>
      </div>
    );
  }

  return (
    <div className="api-key-input-container">
      <Alert
        title="API Key Required"
        description="Enter your API key to test endpoints. The key will be stored locally in your browser."
        type="info"
        showIcon
        style={{ marginBottom: 12 }}
      />
      <Space.Compact style={{ width: '100%' }}>
        <Input.Password
          placeholder="Enter your API key"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onPressEnter={handleSave}
          prefix={<KeyOutlined />}
          style={{ flex: 1 }}
        />
        <Button
          type="primary"
          icon={<CheckOutlined />}
          onClick={handleSave}
          disabled={!inputValue.trim()}
        >
          Save
        </Button>
        {isConfigured && (
          <Button onClick={() => setShowInput(false)}>Cancel</Button>
        )}
      </Space.Compact>
    </div>
  );
};

